module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('i', [_vm._v("KEY WEST HISTORY TIME LINE")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1513—Ponce de Leon is thought to be the first European to discover Florida for Spain. His sailors, watching as they pass the southern islands (the Keys), decide that the mangrove roots look like tortured souls and call them “Los Martires,” or the Martyrs.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Circa 1600—Key West begins to appear on European maps and charts. The first explorers came upon the bones of deceased native tribes, and thus the island was called the Island of Bones, or Cayo Hueso.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The Golden Age of Piracy begins as New World ships carry vast treasures through dangerous waters.")])]), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("1763—The Treaty of Paris gives Florida and Key West to the British and Cuba to the Spanish. The Spanish and Native Americans are forced to leave the Keys and move to Havana. The Spanish, however, claim that the Keys are not part of mainland Florida and are really North Havana. The English say the Keys are a part of Florida. In reality, the dispute is merely a war of words. Hardy souls of many nationalities fish, cut timber, hunt ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("turtles—and avoid pirates—with little restraint from any government.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1783—The Treaty of Paris ends the American Revolution and returns Florida to Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1815—Spain deeds the island of Key West to a loyal Spaniard, Juan Pablo Salas of St. Augustine, Florida.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1819–1922—Florida is ceded to the United States. Salas sells the island to John Simonton for $2,000. Simonton divides the island into four parts, three going to businessmen Whitehead, Fleming and Greene. Cayo Hueso becomes more generally known as Key West.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1822—Simonton convinces the U.S. Navy to come to Key West—the deepwater harbor, which had kept pirates, wreckers and others busy while the land was scarcely developed, would be an incredible asset to the United States. Lieutenant Matthew C. Perry arrives to assess the situation. Perry reports favorably on the strategic military importance but warns the government that the area is filled with unsavory characters—such as pirates.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1823—Captain David Porter is appointed commodore of the West Indies Anti-Pirate Squadron. He takes over ruthlessly, basically putting Key West under martial law. People do not like him. However, starting in 1823, he does begin to put a halt to piracy in the area.")])]), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("The United States of America is in full control of Key West, which is part of the U.S. Territory of Florida, and ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("colonizing begins in earnest by Americans, though, as always, those Americans come from many places.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Circa 1828—Wrecking becomes an important service in Key West, and much of the island becomes involved in the activity. It’s such big business that over the next twenty years, the island becomes one of the richest per capita areas in the United States. In the minds of some, a new kind of piracy has replaced the old. Although wrecking and salvage are licensed and legal, many a ship is lured to its doom by less than scrupulous businessmen.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1845—Florida becomes a state. Construction begins on a fort to protect Key West.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1846—Construction of Fort Jefferson begins in the Dry Tortugas.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1850—The fort on the island of Key West is named after President Zachary Taylor.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("New lighthouses bring about the end of the golden age of wrecking.")])]), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("1861—January 10, Florida secedes from the Union. Fort Zachary Taylor is staunchly held in Union hands and helps defeat the Confederate Navy and control the movement of blockade-runners during the war. Key West remains a divided city throughout the Great Conflict. Construction begins on the East and West Mar")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("tello Towers, which will serve as supply depots. The salt ponds of Key West supply both sides.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1865—The War of Northern Aggression comes to an end with the surrender of Lee at Appomattox Courthouse. Salvage of blockade runners comes to an end.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Dr. Samuel Mudd, deemed guilty of conspiracy for setting John Wilkes Booth’s broken leg after Lincoln’s assassination, is incarcerated at Fort Jefferson, the Dry Tortugas.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("As salt and salvage industries come to an end, cigar making becomes a major business. The Keys are filled with Cuban cigar makers following Cuba’s war of independence, but the cigar makers eventually move to Ybor City. Sponging is also big business for a period, but the sponge divers head for waters near Tampa as disease riddles Key West’s beds and the remote location make industry difficult.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1890—The building that will become known as “the little White House” is built for use as an officer’s quarters at the naval station. President Truman will spend at least 175 days here, and it will be visited by Eisenhower, Kennedy and many other dignitaries.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1898—The USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maine")]), _vm._v(" explodes in Havana Harbor, precipitating the Spanish-American War. Her loss is heavily felt in Key West, as she had been sent from Key West to Havana.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Circa 1900—Robert Eugene Otto is born. At the age of four, he receives the doll he will call Robert, and a legend is born, as well.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1912—Henry Flagler brings the Overseas Railroad to Key West, connecting the islands to the mainland for the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1917—On April 6, the United States enters World War I. Key West maintains a military presence.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1919—Treaty of Versailles ends World War I.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1920s—Prohibition gives Key West a new industry—boot legging.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1927—Pan American Airways is founded in Key West to fly visitors back and forth to Havana.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Carl Tanzler, Count von Cosel, arrives in Key West and takes a job at the Marine Hospital as a radiologist.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1928—Ernest Hemingway comes to Key West. It’s rumored that while waiting for a roadster from the factory, he writes "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Farewell to Arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1931—Hemingway and his wife, Pauline, are gifted with the house on Whitehead Street. Polydactyl cats descend from his pet, Snowball.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Death of Elena Milagro de Hoyos.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1933—Tanzler removes Elena’s body from the cemetery.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1935—The Labor Day Hurricane wipes out the Overseas Railroad and kills hundreds of people. The railroad will not be rebuilt. The Great Depression comes to Key West, as well, and the island, once the richest in the country, struggles with severe unemployment.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1938—An Overseas Highway is completed, U.S. 1, connecting Key West and the Keys to the mainland.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1940—Hemingway and Pauline divorce; Key West loses her great writer, except as a visitor.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Tanzler is found living with Elena’s corpse. Her second viewing at the Dean-Lopez Funeral Home draws thousands of visitors.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1941—December 7, “a date that will live in infamy,” occurs, and the U.S. enters World War II.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Tennessee Williams first comes to Key West.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1945—World War II ends with the Armistice of August 14 (Europe) and the Surrender of Japan, September 2.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Key West struggles to regain a livable economy.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1947—It is believed that Tennessee Williams wrote his first draft of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Streetcar Named Desire")]), _vm._v(" while staying at La Concha Hotel on Duval Street.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1962—The Cuban Missile Crisis occurs. President John F. Kennedy warns the United States that Cuba is only ninety miles away.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1979—The first Fantasy Fest is celebrated.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1980—The Mariel Boatlift brings tens of thousands of Cuban refugees to Key West.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1982—The Conch Republic is born. In an effort to control illegal immigration and drugs, the United States sets up a blockade in Florida City, at the northern end of U.S. 1. Traffic is at a stop for seventeen miles, and the mayor of Key West retaliates on April 23, seceding from the U.S. Key West Mayor Dennis Wardlow declares war, surrenders and demands foreign aid. As the U.S. has never responded, under international law, the Conch Republic still exists. Its foreign policy is stated as, “The Mitigation of World Tension through the Exercise of Humor.” Even though the U.S. never officially recognizes the action, it has the desired effect; the paralyzing blockade is lifted.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1985—Jimmy Buffet opens his first Margaritaville restaurant in Key West.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Fort Zachary Taylor becomes a Florida State Park (and a wonderful place for reenactments, picnics and beach bumming).")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Treasure Hunter Mel Fisher at long last finds the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Atocha.")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("1999—First Pirates in Paradise is celebrated.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("2000–Present—Key West remains a unique paradise itself, garish, loud, charming, filled with history, water sports, family activities and down-and-dirty bars. “The Gibraltar of the East,” she offers diving, shipwrecks and the spirit of adventure that makes her a fabulous destination, for a day, or forever.")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1861d85f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781488099151_fm01.vue
// module id = 69
// module chunks = 0